@if (storeData) {
<div class="fourth-step-container">
  <h2>Here's your summary of your career interests before saving.</h2>

  <!-- Current Role Card -->
  @if (storeData.rolesExperience) {
  <div class="forms">
    <div class="card-header">
      <h3>Current Role</h3>
      <button nz-button nzType="text" class="btn-edit" (click)="moveTo(0)">
        <i class="fa-light fa-pen"></i>
      </button>
    </div>
    <div class="card-body">
      <div class="role-item">
        <div class="role-info">
          <span class="role-category">{{ storeData.rolesExperience.jobCategoryLabel }}</span>
          <span class="role-name">
            @for (special of storeData.rolesExperience.specializations; track special; let last = $last) {
              {{ special.option }}{{ last ? '' : ', ' }}
            }
          </span>
        </div>
        <span class="badge">{{ getExperienceLabel(storeData.rolesExperience.yearsOfExperience) }}</span>
      </div>
    </div>
  </div>

  <!-- Desired Roles Card -->
  <div class="forms">
    <div class="card-header">
      <h3>Desired Roles</h3>
      <button nz-button nzType="text" class="btn-edit" (click)="moveTo(0)">
        <i class="fa-light fa-pen"></i>
      </button>
    </div>
    <div class="card-body">
      @for (role of storeData.rolesExperience.jobProfiles; track role) {
        <div class="role-item">
          <div class="role-info">
            <span class="role-category">{{ role.categoryName }}</span>
            <span class="role-name">{{ role.roleName }}</span>
          </div>
          <span class="badge">{{ role.levelName }}</span>
          <i class="fa-regular fa-trash-can delete-icon"></i>
        </div>
      }
    </div>
  </div>
  }

  <!-- Desired Salary Card -->
  @if (storeData.salaryWorkPreference) {
  <div class="forms">
    <div class="card-header">
      <h3>Desired Salary</h3>
      <button nz-button nzType="text" class="btn-edit" (click)="moveTo(1)">
        <i class="fa-light fa-pen"></i>
      </button>
    </div>
    <div class="card-body">
      <div class="salary-row">
        <span class="salary-value">
          {{ storeData.salaryWorkPreference.currency }} {{ storeData.salaryWorkPreference.expectedSalary ? (storeData.salaryWorkPreference.expectedSalary | number) : 'N/A' }}
        </span>
        @if (storeData.salaryWorkPreference.isSalaryNegotiable) {
          <span class="badge">Flexible salary</span>
        }
      </div>
      @if (storeData.salaryWorkPreference.waysToReachOut) {
        <div class="info-row">
          <span class="info-label">Contact Method:</span>
          <span class="info-value">{{ storeData.salaryWorkPreference.waysToReachOut.toString().split(',').join(' and ') }}</span>
        </div>
      }
    </div>
  </div>

  <!-- Work Preferences Card -->
  <div class="forms">
    <div class="card-header">
      <h3>Work Preferences</h3>
      <button nz-button nzType="text" class="btn-edit" (click)="moveTo(1)">
        <i class="fa-light fa-pen"></i>
      </button>
    </div>
    <div class="card-body">
      <div class="work-pref-row">
        <span class="work-pref-value">{{ preferredWorkLocLabel }}</span>
        @if (storeData.salaryWorkPreference.workRelocation) {
          <span class="badge">{{ getRelocationLabel(storeData.salaryWorkPreference.workRelocation) }}</span>
        }
      </div>
      @if (availabilityLabel) {
        <div class="info-row">
          <span class="info-label">Availability to Start:</span>
          <span class="info-value">{{ availabilityLabel }}</span>
        </div>
      }
    </div>
  </div>
  }

  <!-- LinkedIn Profile Card -->
  @if (storeData.backgroundDetails) {
  <div class="forms">
    <div class="card-header">
      <h3>LinkedIn Profile</h3>
      <button nz-button nzType="text" class="btn-edit" (click)="moveTo(2)">
        <i class="fa-light fa-pen"></i>
      </button>
    </div>
    <div class="card-body">
      @if (storeData.backgroundDetails.linkedInUrl) {
        <a [href]="storeData.backgroundDetails.linkedInUrl" target="_blank" class="linkedin-link">
          <i class="fa-brands fa-linkedin"></i>
          <span>LinkedIn</span>
          <i class="fa-solid fa-arrow-up-right-from-square external-icon"></i>
        </a>
      } @else {
        <span class="no-data">No LinkedIn profile added</span>
      }
    </div>
  </div>

  <!-- Motivation Card -->
  <div class="forms">
    <div class="card-header">
      <h3>Why do you want to join Cloudstaff?</h3>
      <button nz-button nzType="text" class="btn-edit" (click)="moveTo(2)">
        <i class="fa-light fa-pen"></i>
      </button>
    </div>
    <div class="card-body">
      @if (storeData.backgroundDetails.whyJoinToCompany) {
        <p class="motivation-text">{{ storeData.backgroundDetails.whyJoinToCompany }}</p>
      } @else {
        <span class="no-data">No response provided</span>
      }
    </div>
  </div>
  }

</div>
}


